import React from 'react'
import Link from 'gatsby-link'
import Helmet from "react-helmet"
import { Icon, Breadcrumb, Segment, List, Divider, Label } from 'semantic-ui-react'

const IntegrationPage = ({ node }) => {
  return (
    <List.Item>
      <Link to={`/integration/${node.slug}/`}   style={{fontSize: '18pt', margin: '10px'}}>{node.name}</Link>
      </List.Item>
  )
}
const IntegrationsPage = ({ data }) => (
  <div style={{ maxWidth: 1260, margin: '0 auto' }}>
  <Helmet>
        <title>Find growth tools by integration | Find Growth Tools</title>
        <meta name="description" content="A curated list of the best SaaS growth tools that integrate with your favourite apps." />

      </Helmet>
    <Segment basic>
    <Breadcrumb>
      <Breadcrumb.Section>
        <Link to="/" 	style={{color: '#dcddde'}}>
          <Icon name="angle left" />Home
        </Link>
      </Breadcrumb.Section>
      
    </Breadcrumb>
    </Segment>
    <h1
      style={{
        fontSize: '1.5rem',
        color: '#fff'
      }}
    >Find by
      <span style={{fontSize: '3.25rem'}}> Integration</span>
    </h1>
    <br />
    <p style={{fontSize: '1.25em', color: '#fff'}}>Click on products from the list to find growth tools you can integrate.</p>

    <div style={{ maxWidth: 960, margin: '0 auto' }}>
    <Segment>
      <List>
        {data.allContentfulIntegration.edges.map(edge => (
          <IntegrationPage node={edge.node} />
        ))}
      </List>
      </Segment>
    </div>
    <Divider hidden />
  </div>
)

export default IntegrationsPage

export const IntegrationsPageQuery = graphql`
  query IntegrationsPageQuery {
    allContentfulIntegration(
      filter: { node_locale: { eq: "en-US" } }
      sort: { fields: [name], order: ASC }
    ) {
      edges {
        node {
          name
          slug
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/integrations.js